<div class="report-page-container">
	<div class="report-header">
		<div class="title">
			<span *ngIf="pageView === 'report-list'">{{ labels.lbl_geral_reports }}</span>
			<div *ngFor="let reportOption of reportOptionArray">
				<span
					*ngIf="
						(reportOption.spreadsheetView === spreadsheetView && pageView === 'register') ||
						(reportOption.spreadsheetView === spreadsheetView && pageView === 'spreadsheet') ||
						(reportOption.spreadsheetView === spreadsheetView && pageView === 'edit') ||
						(reportOption.pageView === 'extractQr' && pageView === 'extractQr')
					">
					{{ labels.lbl_geral_relatorio }} {{ labels[reportOption.label] }}
				</span>
			</div>
		</div>
		<div class="button-container">
			<div class="button" (click)="exportExcel()" *ngIf="pageView === 'spreadsheet'">{{ labels.lbl_geral_exportar_excel }}</div>
			<div
				class="button"
				(click)="pageView = 'report-list'; unselectAllForm()"
				*ngIf="pageView === 'register' || pageView === 'spreadsheet' || pageView === 'edit' || pageView === 'extractQr'">
				{{ labels.lbl_geral_voltar }}
			</div>
			<a class="button" [routerLink]="'/report'" *ngIf="pageView === 'report-list'">{{ labels.lbl_geral_voltar }}</a>
		</div>
	</div>

	<ng-container *ngIf="pageView === 'report-list'">
		<div class="report-list-container" *ngIf="!isLoadingLabels && !isLoadingRegisterFormOptions">
			<app-cmdb-export-page></app-cmdb-export-page>

			<div class="title mt-4 mb-2">{{ labels.lbl_relatorios_especiais }}</div>

			<div
				class="report-option"
				(click)="pageView = reportOption.pageView; spreadsheetView = reportOption.spreadsheetView; reportOption.function()"
				*ngFor="let reportOption of reportOptionArray">
				<span *ngIf="reportOption.icon"><fa-icon [icon]="reportOption.icon"></fa-icon></span>
				<span>{{ labels[reportOption.label] }}</span>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="(pageView === 'register' && !isLoadingReportList) || (pageView === 'edit' && !isLoadingReportList)">
		<div class="register-report-container" *ngIf="!isLoadingRegisterFormOptions">
			<div class="title" (click)="isRegisterAdvancedOpen = !isRegisterAdvancedOpen">
				<span>{{ labels.lbl_geral_campos_disponiveis }}</span>
				<span [ngClass]="{ 'rotate-90': isRegisterAdvancedOpen }"><fa-icon [icon]="faAngleRight"></fa-icon></span>
			</div>
			<div class="advanced-container" *ngIf="isRegisterAdvancedOpen">
				<div class="tip">{{ labels.lbl_incluir_campos_final_relatorio }}:</div>
				<div class="custom-options-container mb-3">
					<div class="custom-option fixed selected">{{ labels.lbl_filtros_aplicaveis }}</div>
					<div
						class="custom-option"
						[ngClass]="{
							selected: formOption.selected === true,
							fixed: formOption.selected === true,
							unchangeble: formOption.selected === true,
						}"
						*ngFor="let formOption of registerFormOptions"
						(click)="
							formOption.selected = !formOption.selected;
							formOption.selected === true ? selectForm(formOption) : unselectForm(formOption)
						">
						{{ labels[formOption.label] }}
					</div>
				</div>
			</div>

			<div class="custom-options-container">
				<div class="tip">{{ labels.lbl_selecione_filtro_info }}</div>

				<div class="custom-option-input" *ngFor="let formOption of selectedFormOptions">
					<span
						class="label"
						*ngIf="formOption.inputType !== 'boolean' && formOption.inputType !== 'period-date' && formOption.hidden !== true"
						>{{ labels[formOption.label] }}</span
					>
					<input
						type="text"
						(input)="formOption.values[0] = $event.target.value"
						[value]="formOption.values[0]"
						*ngIf="formOption.inputType === 'string'" />
					<select (change)="formOption.values[0] = $event.target.value" *ngIf="formOption.inputType === 'select'">
						<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
						<option
							*ngFor="let option of formOption.items"
							[selected]="formOption.values[0] === option.values"
							[value]="option.values">
							{{ labels[option.label] ? labels[option.label] : option.name }}
						</option>
					</select>
					<div class="date-container" *ngIf="formOption.inputType === 'period-date'">
						<div class="date-label">{{ labels[formOption.label] }}:</div>
						<div class="date-input-container">
							<span class="label">{{ labels.lbl_geral_inicio }}:</span
							><input type="date" (change)="formOption.values[0] = $event.target.value" [value]="formOption.values[0]" />
						</div>
						<div class="date-input-container">
							<span class="label">{{ labels.lbl_geral_fim }}:</span
							><input type="date" (change)="formOption.values[1] = $event.target.value" [value]="formOption.values[1]" />
						</div>
					</div>
					<div class="date-container" *ngIf="formOption.inputType === 'date'">
						<div class="date-input-container">
							<input type="date" (change)="formOption.values[0] = $event.target.value" [value]="formOption.values[0]" />
						</div>
					</div>
				</div>
			</div>

			<div class="button-container">
				<div class="button mt-2 mb-4" (click)="createReport()" *ngIf="pageView === 'register'">
					{{ labels.lbl_rep_gerar_relatorio }}
				</div>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="pageView === 'spreadsheet'">
		<br />
		<div class="report-table-container" *ngIf="!isLoadingReportList">
			<table id="report-table" datatable [dtOptions]="dtOptions" class="row-border hover">
				<thead>
					<tr class="header">
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_asset_tipo_ci }}</th>
						<th *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">{{ labels.lbl_cmdb }}</th>
						<th *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">
							{{ labels.lbl_geral_identificacao }}
						</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_geral_cliente }}</th>
						<th *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">
							{{ labels.lbl_geral_usuario }}
						</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_geral_data_compra }}</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_asset_depreciacao_mensal }}</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_geral_pedido_compra }}</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_geral_preco }}</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_geral_projeto }}</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_asset_termino_depreciacao }}</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_geral_tipo_garantia }}</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_cmdb_expiration }}</th>
						<th *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">
							{{ labels.lbl_geral_localidade }}
						</th>
						<th *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">
							{{ labels.lbl_geral_depto }}
						</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_geral_impacto }}</th>
						<th
							*ngIf="
								(spreadsheetView === 'reportCost' && handleMockHideForms() === false) ||
								(spreadsheetView === 'withoutRelated' && handleMockHideForms() === false)
							">
							{{ labels.lbl_geral_centro_custo }}
						</th>
						<th
							*ngIf="
								(spreadsheetView === 'reportCost' && handleMockHideForms() === true) ||
								(spreadsheetView === 'withoutRelated' && handleMockHideForms() === true)
							">
							{{ labels.lbl_geral_centro_custo }}
						</th>
						<th *ngIf="spreadsheetView === 'withoutRelated'">{{ labels.lbl_geral_modelo }}</th>
						<th *ngIf="spreadsheetView === 'withoutRelated'">{{ labels.lbl_chamado_data_abertura }}</th>
						<th *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ labels.lbl_geral_identificacao }}</th>
						<th *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ labels.lbl_geral_result_type }}</th>
						<th *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ labels.lbl_enquete_resultado_1 }}</th>
						<th *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ labels.lbl_geral_detalhes }}</th>
						<th *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ labels.lbl_geral_data_hora_inicial }}</th>
						<th *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ labels.lbl_geral_data_hora_final }}</th>
						<th *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ labels.lbl_geral_affected_lines }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_identificacao }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_asset_tipo_ci }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_status }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_preco }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_data_compra }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_asset_termino_depreciacao }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_cmdb_deactivation_date }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_periodo }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_asset_depreciacao_mensal }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_usage_time }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_accumulated_depreciation }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_prejudice }}</th>
						<th *ngIf="spreadsheetView === 'software'">{{ labels.lbl_geral_nome_do_host }}</th>
						<th *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">
							{{ labels.lbl_geral_software_name }}
						</th>
						<th *ngIf="spreadsheetView === 'software'">{{ labels.lbl_geral_data_instalacao }}</th>
						<th *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">
							{{ labels.lbl_geral_versao }}
						</th>
						<th *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">
							{{ labels.lbl_geral_licenciavel }}
						</th>
						<th *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">
							{{ labels.lbl_geral_status }}
						</th>
						<th *ngIf="spreadsheetView === 'software_x_license'">{{ labels.lbl_geral_qtd_contratada }}</th>
						<th *ngIf="spreadsheetView === 'software_x_license'">{{ labels.lbl_geral_qtd_disponivel }}</th>
						<th *ngIf="spreadsheetView === 'software_x_license'">{{ labels.lbl_geral_qtd_instaladas }}</th>
						<th *ngIf="spreadsheetView === 'software'">{{ labels.lbl_cmdb_last_modification_date }}</th>
						<th *ngIf="spreadsheetView === 'software'">{{ labels.lbl_geral_controle_de_uso }}</th>
						<th *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">
							{{ labels.lbl_geral_depto }}
						</th>
						<th *ngIf="spreadsheetView === 'software'">{{ labels.lbl_geral_usuario }}</th>
						<th *ngIf="spreadsheetView === 'reportAD'">{{ labels.lbl_geral_nome_do_host }}</th>
						<th *ngIf="spreadsheetView === 'reportAD'">{{ labels.lbl_geral_tag_id }}</th>
						<th *ngIf="spreadsheetView === 'reportAD'">{{ labels.lbl_geral_site }}</th>
						<th *ngIf="spreadsheetView === 'reportAD'">{{ labels.lbl_geral_depto }}</th>
						<th *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ labels.lbl_geral_nome_do_host }}</th>
						<th *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ labels.lbl_geral_tag_id }}</th>
						<th *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ labels.lbl_geral_localidade }}</th>
						<th *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ labels.lbl_geral_depto }}</th>
						<th *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ labels.lbl_asset_proprietario }}</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of consumablesInterface">
						<td *ngIf="spreadsheetView === 'reportCost'">{{ labels[item.ciType] }}</td>
						<td *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">{{ item.cmdbId }}</td>
						<td *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">{{ item.identification }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.customer }}</td>
						<td *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">{{ item.enduser }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.purchaseDate }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.monthlyDepreciation }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.purchaseOrder }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.price }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.project }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.endOfDepreciation }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.warrantyType }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.warrantyExpiration }}</td>
						<td *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">{{ item.location }}</td>
						<td *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">{{ item.department }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.impact }}</td>
						<td
							*ngIf="
								(spreadsheetView === 'reportCost' && handleMockHideForms() === false) ||
								(spreadsheetView === 'withoutRelated' && handleMockHideForms() === false)
							">
							{{ item.costCenter }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'reportCost' && handleMockHideForms() === true) ||
								(spreadsheetView === 'withoutRelated' && handleMockHideForms() === true)
							">
							{{ item.ccCustomer }}
						</td>
						<td *ngIf="spreadsheetView === 'withoutRelated'">{{ item.modelName }}</td>
						<td *ngIf="spreadsheetView === 'withoutRelated'">{{ item.creationDate }}</td>
						<td *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ item.inventory_name }}</td>
						<td *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ item.result_type }}</td>
						<td *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ item.result }}</td>
						<td *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ item.details }}</td>
						<td *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ item.start_datetime }}</td>
						<td *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ item.end_datetime }}</td>
						<td *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ item.rows_affected }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.identification }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels[item.type] }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.status }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.price }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.purchase_date }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.depreciation_limit }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.deactivation_date }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.days_difference }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.monthly_depreciation }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.time_use }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.accumulated_depreciation }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.prejudice }}</td>
						<td *ngIf="spreadsheetView === 'software'">{{ item.computer_name }}</td>
						<td *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">{{ item.software_name }}</td>
						<td *ngIf="spreadsheetView === 'software'">{{ item.instalation_date }}</td>
						<td *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">{{ item.version }}</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.is_licensable === 'N') ||
								(spreadsheetView === 'software_x_license' && item.is_licensable === 'N')
							">
							{{ labels.lbl_geral_nao }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.is_licensable === 'S') ||
								(spreadsheetView === 'software_x_license' && item.is_licensable === 'S')
							">
							{{ labels.lbl_geral_sim }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.is_licensable === 'UNKNOWN') ||
								(spreadsheetView === 'software_x_license' && item.is_licensable === 'UNKNOWN')
							">
							{{ labels.lbl_geral_nao }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === 'Ativo') ||
								(spreadsheetView === 'software_x_license' && item.status === 'Ativo')
							">
							{{ labels.lbl_geral_ativo }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === 'Estoque') ||
								(spreadsheetView === 'software_x_license' && item.status === 'Estoque')
							">
							{{ labels.lbl_status_estoque }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === 'Descontinuado') ||
								(spreadsheetView === 'software_x_license' && item.status === 'Descontinuado')
							">
							{{ labels.lbl_geral_descontinuado }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === 'Em renovação') ||
								(spreadsheetView === 'software_x_license' && item.status === 'Em renovação')
							">
							{{ labels.lbl_geral_em_renovacao }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === 'Manutenção') ||
								(spreadsheetView === 'software_x_license' && item.status === 'Manutenção')
							">
							{{ labels.lbl_status_em_manutencao }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === 'Inativo - sem comunicação > 45 dias') ||
								(spreadsheetView === 'software_x_license' && item.status === 'Inativo - sem comunicação > 45 dias')
							">
							{{ labels.lbl_geral_inativo }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === 'N/A') ||
								(spreadsheetView === 'software_x_license' && item.status === 'N/A')
							">
							N/A
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === '') ||
								(spreadsheetView === 'software_x_license' && item.status === '')
							">
							N/A
						</td>
						<td *ngIf="spreadsheetView === 'software'">{{ item.last_modification_date }}</td>
						<td *ngIf="spreadsheetView === 'software'">{{ item.use_control }}</td>
						<td *ngIf="spreadsheetView === 'software_x_license'">{{ item.qtd_contratada }}</td>
						<td *ngIf="spreadsheetView === 'software_x_license'">{{ item.qtd_disponiveis }}</td>
						<td *ngIf="spreadsheetView === 'software_x_license'">{{ item.qtd_instalada }}</td>
						<td *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">{{ item.department }}</td>
						<td *ngIf="spreadsheetView === 'software'">{{ item.full_name }}</td>
						<td *ngIf="spreadsheetView === 'reportAD'">{{ item.name }}</td>
						<td *ngIf="spreadsheetView === 'reportAD'">{{ item.tag_id }}</td>
						<td *ngIf="spreadsheetView === 'reportAD'">{{ item.site }}</td>
						<td *ngIf="spreadsheetView === 'reportAD'">{{ item.department }}</td>
						<td *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ item.identification }}</td>
						<td *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ item.tag_id }}</td>
						<td *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ item.location }}</td>
						<td *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ item.department }}</td>
						<td *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ item.full_name }}</td>
					</tr>
				</tbody>
			</table>

			<table hidden id="excel-table">
				<thead>
					<tr class="header">
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_asset_tipo_ci }}</th>
						<th *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">{{ labels.lbl_cmdb }}</th>
						<th *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">
							{{ labels.lbl_geral_identificacao }}
						</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_geral_cliente }}</th>
						<th *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">
							{{ labels.lbl_geral_usuario }}
						</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_geral_data_compra }}</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_asset_depreciacao_mensal }}</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_geral_pedido_compra }}</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_geral_preco }}</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_geral_projeto }}</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_asset_termino_depreciacao }}</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_geral_tipo_garantia }}</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_cmdb_expiration }}</th>
						<th *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">
							{{ labels.lbl_geral_localidade }}
						</th>
						<th *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">
							{{ labels.lbl_geral_depto }}
						</th>
						<th *ngIf="spreadsheetView === 'reportCost'">{{ labels.lbl_geral_impacto }}</th>
						<th
							*ngIf="
								(spreadsheetView === 'reportCost' && handleMockHideForms() === false) ||
								(spreadsheetView === 'withoutRelated' && handleMockHideForms() === false)
							">
							{{ labels.lbl_geral_centro_custo }}
						</th>
						<th
							*ngIf="
								(spreadsheetView === 'reportCost' && handleMockHideForms() === true) ||
								(spreadsheetView === 'withoutRelated' && handleMockHideForms() === true)
							">
							{{ labels.lbl_geral_centro_custo }}
						</th>
						<th *ngIf="spreadsheetView === 'withoutRelated'">{{ labels.lbl_geral_modelo }}</th>
						<th *ngIf="spreadsheetView === 'withoutRelated'">{{ labels.lbl_chamado_data_abertura }}</th>
						<th *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ labels.lbl_geral_identificacao }}</th>
						<th *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ labels.lbl_geral_result_type }}</th>
						<th *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ labels.lbl_enquete_resultado_1 }}</th>
						<th *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ labels.lbl_geral_detalhes }}</th>
						<th *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ labels.lbl_geral_data_hora_inicial }}</th>
						<th *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ labels.lbl_geral_data_hora_final }}</th>
						<th *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ labels.lbl_geral_affected_lines }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_identificacao }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_asset_tipo_ci }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_status }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_preco }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_data_compra }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_asset_termino_depreciacao }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_cmdb_deactivation_date }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_periodo }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_asset_depreciacao_mensal }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_usage_time }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_accumulated_depreciation }}</th>
						<th *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels.lbl_geral_prejudice }}</th>
						<th *ngIf="spreadsheetView === 'software'">{{ labels.lbl_geral_nome_do_host }}</th>
						<th *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">
							{{ labels.lbl_geral_software_name }}
						</th>
						<th *ngIf="spreadsheetView === 'software'">{{ labels.lbl_geral_data_instalacao }}</th>
						<th *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">
							{{ labels.lbl_geral_versao }}
						</th>
						<th *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">
							{{ labels.lbl_geral_licenciavel }}
						</th>
						<th *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">
							{{ labels.lbl_geral_status }}
						</th>
						<th *ngIf="spreadsheetView === 'software_x_license'">{{ labels.lbl_geral_qtd_contratada }}</th>
						<th *ngIf="spreadsheetView === 'software_x_license'">{{ labels.lbl_geral_qtd_disponivel }}</th>
						<th *ngIf="spreadsheetView === 'software_x_license'">{{ labels.lbl_geral_qtd_instaladas }}</th>
						<th *ngIf="spreadsheetView === 'software'">{{ labels.lbl_cmdb_last_modification_date }}</th>
						<th *ngIf="spreadsheetView === 'software'">{{ labels.lbl_geral_controle_de_uso }}</th>
						<th *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">
							{{ labels.lbl_geral_depto }}
						</th>
						<th *ngIf="spreadsheetView === 'software'">{{ labels.lbl_geral_usuario }}</th>
						<th *ngIf="spreadsheetView === 'reportAD'">{{ labels.lbl_geral_nome_do_host }}</th>
						<th *ngIf="spreadsheetView === 'reportAD'">{{ labels.lbl_geral_tag_id }}</th>
						<th *ngIf="spreadsheetView === 'reportAD'">{{ labels.lbl_geral_site }}</th>
						<th *ngIf="spreadsheetView === 'reportAD'">{{ labels.lbl_geral_depto }}</th>
						<th *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ labels.lbl_geral_nome_do_host }}</th>
						<th *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ labels.lbl_geral_tag_id }}</th>
						<th *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ labels.lbl_geral_localidade }}</th>
						<th *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ labels.lbl_geral_depto }}</th>
						<th *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ labels.lbl_asset_proprietario }}</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of consumablesInterface">
						<td *ngIf="spreadsheetView === 'reportCost'">{{ labels[item.ciType] }}</td>
						<td *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">{{ item.cmdbId }}</td>
						<td *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">{{ item.identification }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.customer }}</td>
						<td *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">{{ item.enduser }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.purchaseDate }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.monthlyDepreciation }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.purchaseOrder }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.price }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.project }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.endOfDepreciation }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.warrantyType }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.warrantyExpiration }}</td>
						<td *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">{{ item.location }}</td>
						<td *ngIf="spreadsheetView === 'reportCost' || spreadsheetView === 'withoutRelated'">{{ item.department }}</td>
						<td *ngIf="spreadsheetView === 'reportCost'">{{ item.impact }}</td>
						<td
							*ngIf="
								(spreadsheetView === 'reportCost' && handleMockHideForms() === false) ||
								(spreadsheetView === 'withoutRelated' && handleMockHideForms() === false)
							">
							{{ item.costCenter }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'reportCost' && handleMockHideForms() === true) ||
								(spreadsheetView === 'withoutRelated' && handleMockHideForms() === true)
							">
							{{ item.ccCustomer }}
						</td>
						<td *ngIf="spreadsheetView === 'withoutRelated'">{{ item.modelName }}</td>
						<td *ngIf="spreadsheetView === 'withoutRelated'">{{ item.creationDate }}</td>
						<td *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ item.inventory_name }}</td>
						<td *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ item.result_type }}</td>
						<td *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ item.result }}</td>
						<td *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ item.details }}</td>
						<td *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ item.start_datetime }}</td>
						<td *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ item.end_datetime }}</td>
						<td *ngIf="spreadsheetView === 'logIntegrationInventory'">{{ item.rows_affected }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.identification }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ labels[item.type] }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.status }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.price }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.purchase_date }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.depreciation_limit }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.deactivation_date }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.days_difference }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.monthly_depreciation }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.time_use }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.accumulated_depreciation }}</td>
						<td *ngIf="spreadsheetView === 'calculateMonthlyDepreciation'">{{ item.prejudice }}</td>
						<td *ngIf="spreadsheetView === 'software'">{{ item.computer_name }}</td>
						<td *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">{{ item.software_name }}</td>
						<td *ngIf="spreadsheetView === 'software'">{{ item.instalation_date }}</td>
						<td *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">{{ item.version }}</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.is_licensable === 'N') ||
								(spreadsheetView === 'software_x_license' && item.is_licensable === 'N')
							">
							{{ labels.lbl_geral_nao }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.is_licensable === 'S') ||
								(spreadsheetView === 'software_x_license' && item.is_licensable === 'S')
							">
							{{ labels.lbl_geral_sim }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.is_licensable === 'UNKNOWN') ||
								(spreadsheetView === 'software_x_license' && item.is_licensable === 'UNKNOWN')
							">
							{{ labels.lbl_geral_nao }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === 'Ativo') ||
								(spreadsheetView === 'software_x_license' && item.status === 'Ativo')
							">
							{{ labels.lbl_geral_ativo }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === 'Estoque') ||
								(spreadsheetView === 'software_x_license' && item.status === 'Estoque')
							">
							{{ labels.lbl_status_estoque }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === 'Descontinuado') ||
								(spreadsheetView === 'software_x_license' && item.status === 'Descontinuado')
							">
							{{ labels.lbl_geral_descontinuado }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === 'Em renovação') ||
								(spreadsheetView === 'software_x_license' && item.status === 'Em renovação')
							">
							{{ labels.lbl_geral_em_renovacao }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === 'Manutenção') ||
								(spreadsheetView === 'software_x_license' && item.status === 'Manutenção')
							">
							{{ labels.lbl_status_em_manutencao }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === 'Inativo - sem comunicação > 45 dias') ||
								(spreadsheetView === 'software_x_license' && item.status === 'Inativo - sem comunicação > 45 dias')
							">
							{{ labels.lbl_geral_inativo }}
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === 'N/A') ||
								(spreadsheetView === 'software_x_license' && item.status === 'N/A')
							">
							N/A
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === '') ||
								(spreadsheetView === 'software_x_license' && item.status === '')
							">
							N/A
						</td>
						<td
							*ngIf="
								(spreadsheetView === 'software' && item.status === '') ||
								(spreadsheetView === 'software_x_license' && item.status === '')
							">
							{{ labels.lbl_geral_inativo }}
						</td>
						<td *ngIf="spreadsheetView === 'software'">{{ item.last_modification_date }}</td>
						<td *ngIf="spreadsheetView === 'software'">{{ item.use_control }}</td>
						<td *ngIf="spreadsheetView === 'software_x_license'">{{ item.qtd_contratada }}</td>
						<td *ngIf="spreadsheetView === 'software_x_license'">{{ item.qtd_disponiveis }}</td>
						<td *ngIf="spreadsheetView === 'software_x_license'">{{ item.qtd_instalada }}</td>
						<td *ngIf="spreadsheetView === 'software' || spreadsheetView === 'software_x_license'">{{ item.department }}</td>
						<td *ngIf="spreadsheetView === 'software'">{{ item.full_name }}</td>
						<td *ngIf="spreadsheetView === 'reportAD'">{{ item.name }}</td>
						<td *ngIf="spreadsheetView === 'reportAD'">{{ item.tag_id }}</td>
						<td *ngIf="spreadsheetView === 'reportAD'">{{ item.site }}</td>
						<td *ngIf="spreadsheetView === 'reportAD'">{{ item.department }}</td>
						<td *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ item.identification }}</td>
						<td *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ item.tag_id }}</td>
						<td *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ item.location }}</td>
						<td *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ item.department }}</td>
						<td *ngIf="spreadsheetView === 'reportMicroNotAD'">{{ item.full_name }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</ng-container>

	<ng-container *ngIf="pageView === 'extractQr'">
		<div class="qr-report-container" *ngIf="!isLoadingQrCodes && !isLoadingBarCodes">
			<div class="qr-report-data">
				{{
					labels.lbl_existem_qtd_ativos_sem_campo_registrado
						.replace('§qtd§', cisWithoutQrCode.length)
						.replace('§field§', labels.lbl_geral_qrcode)
				}}!
			</div>
			<div class="qr-report-data">
				{{
					labels.lbl_existem_qtd_ativos_com_campo_registrado
						.replace('§qtd§', cisWithQrCode.length)
						.replace('§field§', labels.lbl_geral_qrcode)
				}}!
			</div>

			<div class="qr-report-data">
				{{
					labels.lbl_existem_qtd_ativos_sem_campo_registrado
						.replace('§qtd§', cisWithoutBarCode.length)
						.replace('§field§', labels.lbl_geral_barcode)
				}}!
			</div>
			<div class="qr-report-data">
				{{
					labels.lbl_existem_qtd_ativos_com_campo_registrado
						.replace('§qtd§', cisWithBarCode.length)
						.replace('§field§', labels.lbl_geral_barcode)
				}}
			</div>

			<div class="button-container">
				<div class="button" (click)="downloadAllQrCodes('qrcode')">_Imprimir todos qrCodes registrados</div>
				<div class="button" (click)="downloadAllQrCodes('barcode')">_Imprimir todos barCodes registrados</div>
			</div>
		</div>

		<cpi-dot-bounce-loading-effect
			class="mt-2 ml-2"
			[color]="'var(--primary-color-1)'"
			*ngIf="isLoadingQrCodes || isLoadingBarCodes"></cpi-dot-bounce-loading-effect>
	</ng-container>

	<div class="loading-container" *ngIf="isLoadingReportList || isLoadingRegisterFormOptions || isLoadingLabels">
		<cpi-svg-gears></cpi-svg-gears>
		<div>{{ labels.lbl_edocs_carregando }}!</div>
	</div>
</div>
